import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import find from "lodash/find";
import moment from "moment";
import sortBy from "lodash/sortBy";
import { connect } from "react-redux";
import {
  Card,
  Button,
  CardTitle,
  CardText,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Row,
  Col,
  Modal,
  ModalBody,
} from "reactstrap";

import Loading from "../../../hoc/Loading/Loading";
import axios from "../../../axios";
import * as actionCreators from "../../../modules/actions/index";
import {
  kpiBasedType,
  chartLineColor,
  plotlyMarkerTypes,
  benchmarkLineTypes,
  dtickFormat,
  legendPosition,
  selectOfficeCheck,
  findNodeinHierarchy,
  returnHierarchyGroup,
  KPISbyMonth,
  chartMarkerSymbolsVariation,
  chartMarkerSymbols,
  chartParams,
  getEmptyGraphLayoutObject,
  checkNoDataLayoutValidity,
  mergeLayoutAnnotations,
  renderGenderPronoun,
  getAvgTenureFormatted,
} from "../../../utils/constants";
import ChartEmptyState from "../Components/ChartEmptyState/ChartEmptyState";
import {
  getGenderLists,
  createKPIAgreegateRequestDataRefreshChart,
  getAllOccupationAndSeniorityValues,
} from "../../../utils/filterKpisData";
import { chartKpiDataFieldRefTransformationSingleChart, generateLegendTitle } from "../../../utils/chartUtils";
import Plot from "../../../utils/customPlotly";
import ManualEntryModal from "../../../pages/analytics/ChartList/ManualEntryModal";
import * as url from "../../../utils/url";
import { ensureMappings } from "../../../utils/ensureMappings";
import ChartInsights from "../Insight/ChartInsights";
// import CKEditorUI from '../../../components/CKEditor/CKEditorUI';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ChartDashboards from "./ChartDashboards";
import { isMobile } from "../../../utils/deviceInfo";
import ChartAverageTable from "./ChartAverageTable";
import LockUnlockChartComponent from "../../../components/LockUnlockChart/LockUnlockChartComponent";
import { deepClone } from "../../../utils/copyObject";

class ViewSingleChart extends Component {
  chartMenuRef = React.createRef();
  chartMenuBtnRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      chart: null,
      showViewChart: false,
      openCreateChartReport: false,
      clickedPoint: null,
      description: "",
      showManualEntryAnswersModal: false,
      plotlyData: null,
      dropdownOpen: false,
      startDate: null,
      filteredChart: {},
      endDate: moment(new Date()),
      dropdownFilter: false,
      isChartNotesDisplay: this.props.isChartNotesDisplay
        ? this.props.isChartNotesDisplay
        : false,
      dropdownSingleChartViewChange: false,
      showLinkedDashboards: false,
      annotations:[]
    };
  }

  componentWillUnmount = () => {
    this.props.updateNavBar({
      backButtonData: {
        show: false,
        currentPageType: "",
      },
    });
  };

  componentDidMount() {
    this.props.updateNavBar({
      backButtonData: {
        show: true,
        currentPageType: "CHART_DETAILS",
      },
    });

    // console.log(this.props.chart, " --- props ----", this.props.reports);
    let { chart } = this.props;
    let selected = this.props.reports.charts.filter(
      (e) => e._id.toString() == chart._id.toString()
    );
    if (selected && selected.length > 0) {
      // console.log("selected: ", selected);
      selected = selected[0];
      if (selected && selected.name) {
        let { startDate, endDate } = chart;
        let res = this.processKpiData(selected, { startDate, endDate });
        // console.log("res: ", res);
        this.setState({
          chart: { ...res },
        });
      }
    } else {
      let { startDate, endDate } = chart;
      let res = this.processKpiData(chart, { startDate, endDate });
      // console.log("res: ", res);
      this.setState({
        chart: { ...res },
        showLinkedDashboards: this.props.showLinkedDashboards,
      });
    }
    document.addEventListener("mousedown", this.handleDbClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleDbClickOutside);
  }

  handleDbClickOutside = (event) => {
    //  console.log('event.target: ', event.target)
    let chartMenu =
      this.chartMenuRef &&
      this.chartMenuRef.current &&
      !this.chartMenuRef.current.contains(event.target);
    let chartMenuBtn =
      this.chartMenuBtnRef &&
      this.chartMenuBtnRef.current &&
      !this.chartMenuBtnRef.current.contains(event.target);

    if (chartMenu) {
      if (chartMenuBtn && chartMenu) {
        this.closeFilterMenu();
      }
    }
  };

  closeFilterMenu = () => {
    this.setState((prevState) => ({ dropdownFilter: false }));
  };

  componentDidUpdate(prevProps, prevState) {
    let { chart, startDate, endDate } = this.props;

    let sdate = chart.xMinDate ? chart.xMinDate : chart.startDate;
    let edate = chart.xMaxDate ? chart.xMaxDate : chart.endDate;

    let ch_start = moment(sdate);
    let ch_end = moment(edate);

    let init_start = moment(startDate);
    let init_end = moment(endDate);

    if (
      (startDate && startDate != prevProps.startDate) ||
      (endDate && endDate != prevProps.endDate)
    ) {
      if (
        init_start.diff(ch_start, "days") != 0 ||
        init_end.diff(ch_end, "days") != 0
      ) {
        this.refreshChart();
      }
    }
  }

  updateChartPointers = (pointIndex, curveIndex) => {
    let currentChartObject = { ...this.state.chart };

    const kpiForPlotlyArray = currentChartObject.kpiForPlotly
      ? [...currentChartObject.kpiForPlotly]
      : [];

    let kpiForPlotlyObject = kpiForPlotlyArray[curveIndex];

    if (kpiForPlotlyObject) {
      const marker = kpiForPlotlyObject.marker;

      // marker.color = "rgb(255,0,0)"

      if (marker) {
        const new_color = marker.color;

        new_color[pointIndex] = "rgb(255,0,0)";

        marker.color = deepClone(new_color);

        kpiForPlotlyObject = {
          ...kpiForPlotlyObject,
          marker,
        };

        kpiForPlotlyArray[curveIndex] = kpiForPlotlyObject;

        currentChartObject = {
          ...currentChartObject,
          kpiForPlotly: [...kpiForPlotlyArray],
        };

        this.setState({ chart: currentChartObject });
      }
    }
  };

  resetChartPointers = () => {
    const { chart } = this.state;

    const newCharts = {
      ...chart,
      kpiForPlotly: chart.kpiForPlotly.map((kpi, idx) => ({
        ...kpi,
        marker: {
          ...kpi.marker,
          color:
            kpi.x && kpi.x.length && kpi.line
              ? [...Array(kpi.x.length).fill(kpi.line.color)]
              : chartLineColor(idx),
        },
      })),
    };

    this.setState({ chart: newCharts });
  };

  refreshChart = async () => {
    let { mappingMaster, user } = this.props;
    let { chart, startDate, endDate } = this.state;
    let { kpiType, kpiData, selectedOffice } = chart;
    let chartId = chart._id;
    let organizationId = user.profile.organizationId;
    let { staticHierarchy } = organizationId;

    // Mappings may not be in redux yet on a cold direct visit — wait for them
    // before building the refresh request.
    let mappingMasterList;
    try {
      mappingMasterList = await ensureMappings(
        organizationId,
        mappingMaster.mappingMasterList,
        this.props.onMappingMasterListFetched
      );
    } catch (error) {
      console.log("error fetching mapping master list: ", error);
      return;
    }

    // console.log(startDate, moment(startDate) )
    // let dateRange = {startDate, endDate}
    let results = {};
    let kpiRequestData;
    let {
      allOccupationValues,
      allSeniorityValues,
    } = getAllOccupationAndSeniorityValues(mappingMasterList);
    let KRD = kpiData.map((kpi) => {
      if (kpiType === kpiBasedType.empDataBased) {
        return createKPIAgreegateRequestDataRefreshChart(
          kpi,
          mappingMasterList,
          allOccupationValues,
          allSeniorityValues
        );
      } else if (kpiType === kpiBasedType.surveyBased) {
        return { code: kpi.kpiId.code };
      }
    });
    let orgMapping = mappingMasterList;
    let genderMapping = getGenderLists(orgMapping);
    results = { kpiList: KRD, ...genderMapping, kpiType };

    if (selectedOffice && selectedOffice.value) {
      if (chart && chart.kpiType != "SURVEY_BASED") {
        results["allOfficeKeys"] = returnHierarchyGroup(
          staticHierarchy,
          selectedOffice.value
        );
      }
      results["officeKey"] = selectedOffice.value;
      results["missingSelectedOffice"] = false;
    } else {
      let nameArr = chart.officeId.officeHierarchyPath.split("#");
      let name = nameArr[nameArr.length - 1];
      let office = staticHierarchy.filter((e) => e.id === name)[0];
      if (chart && chart.kpiType != "SURVEY_BASED") {
        results["allOfficeKeys"] = returnHierarchyGroup(
          staticHierarchy,
          office.officeKey
        );
      }
      results["officeKey"] = office.officeKey;
      results["missingSelectedOffice"] = true;
      results["officeData"] = office;
    }
    results["_id"] = chartId;
    results["isUpdate"] = { status: true, chart: true };

    let chartStartDate =
      moment(startDate).format("YYYY-MM-DD") + "T00:00:00.000Z";
    let chartEndDate = moment(endDate).format("YYYY-MM-DD") + "T23:59:59.000Z";
    results["startDate"] = chartStartDate;
    results["endDate"] = chartEndDate;

    let that = this;
    // console.log('Chart Name: ', chart.name)
    // console.log('result Chart: ', results)

    if (this.state.showLinkedDashboards) {
      results["filters"] = { _id: this.state.chart._id };
    } else {
      results["filters"] = {
        _id: this.state.chart._id,
        dashboardId: this.props.reports._id,
      };
    }

    // results['dashboardUpdate'] = dateRange

    if (this.props.reports.startDate) {
      results["old_date_range"] = {
        startDate: this.props.reports.startDate,
        endDate: this.props.reports.endDate,
      };
    } else {
      results["old_date_range"] = null;
    }

    results["dontUpdateChart"] = true;

    axios
      .post(url.previewDashboardChartData(chart._id), results)
      .then((response) => {
        let { chart, dashboard } = response.data.data;
        // console.log("chart:  ", chart);

        let updatedChart = this.processKpiData(chart, { startDate, endDate });
        //  updatedChart.isChartUpdated = true

        // console.log("updatedChart:  ", updatedChart);

        that.setState({
          filteredChart: updatedChart,
        });

        // that.renderPlot(updatedChart)
        // that.props.refreshChart(updatedChart, dateRange)
        // that.props.updateReport(dashboard)
      })
      .catch((error) => {
        console.log("err--", error);
      });
  };

  renderFilterDropdown = () => {
    let { dropdownFilter } = this.state;
    let { chart } = this.props;
    // console.log('dropdownFilter: ', dropdownFilter)

    if (dropdownFilter) {
      return (
        <ul className="dbChartMenuOptions" ref={this.chartMenuRef}>
          <ol onClick={() => this.navigateToChart(chart)}> View </ol>
          <ol className="dbChartRemove" onClick={() => this.removeChart(chart)}>
            {" "}
            <i className="flaticon-trash" /> Remove{" "}
          </ol>
          {/* <span className='dbFilterLabel'>Choose filters</span>
        {activeFilterMenu==''?
        <span>
          
          <ol onClick={()=>this.showFilterMenu('date')}> Date Range </ol>
          <ol onClick={()=>this.showFilterMenu('category')}> Category </ol>
        </span>
        :
        this.renderActiveMenu()
      } */}
        </ul>
      );
    }
  };

  chartLineMarkerGenerator = (color, type, length) => {
    // let value = Math.floor(Math.random()*16777215).toString(16)
    // let color = `#${value}`.toUpperCase();
    let obj;

    if (type === "line") {
      obj = {
        color,
        width: 1,
      };
    } else {
      let marker = Math.floor(Math.random() * 9);
      let variation = Math.floor(Math.random() * 3);
      let symbol = `${chartMarkerSymbols[marker]}${chartMarkerSymbolsVariation[variation]}`;
      obj = {
        color: [...Array(length).fill(color)],
        size: 10,
        symbol,
      };
    }
    return obj;
  };

  kpiGoalValue = (chart, kpi, index) => {
    if (chart && chart.goals && chart.goals.length > 0) {
      if (kpi && kpi.kpiId && kpi.kpiId._id) {
        let result = chart.goals.filter(
          (e) =>
            e.kpiId === kpi.kpiId._id &&
            parseInt(e.name.match(/\d+/)[0]) === index + 1
        );
        if (result && result.length > 0) {
          return result[0];
        }
      }
    }
    return {};
  };

  handleChartPointClick = (a) => {
    let { chart } = this.state;
    if (chart && chart.name && chart.kpiType) {
      let { kpiType } = chart;
      if (kpiType === kpiBasedType.surveyBased) {
        this.setState({
          showManualEntryAnswersModal: true,
          clickedPoint: a,
        });
      }
    }

    const annotations_old = [...this.state.annotations];

    const getAvgTenureIfAvailable=(pointData,pointIndex)=>{
      if(pointData && pointIndex>=0){
        if(pointData.data && pointData.data.text && pointData.data.text.length){
          for (const str of pointData.data.text[pointIndex]) {
            if(str.indexOf("Avg Tenure")>=0){
              return ", "+str;
            }
          }
        }
      }
      return "";
    }

    if (a.points && a.points[0] && a.points[0].data) {
      const pointIndex = a.points[0].pointIndex;
      const curveIndex = a.points[0].curveNumber;
      const pointData = a.points[0];
      let annotate_text = `${pointData.text[0]}, ${Math.round(pointData.y *
        100)}% ${getAvgTenureIfAvailable(pointData,pointIndex)}`;

      let annotation = {
        text: annotate_text,
        x: pointData.x,
        y: parseFloat(pointData.y.toPrecision(2)),
        borderwidth:1,
        clicktoshow:"onoff"
      };

      annotations_old.push(annotation);

      this.setState({ annotations: annotations_old });

     
        this.updateChartPointers(
  
          pointIndex,
          curveIndex
        );
      
    }
  };

  handleChartPointDoubleClick = (a) => {
    this.setState({ annotations: [] });
      this.resetChartPointers();
    
  };

  openChartMenu = () => {
    this.setState((prevState) => ({
      dropdownFilter: !prevState.dropdownFilter,
    }));
  };

  onPlotlyUpdate = (plot) => {
    let { rangeInit } = this.state;
    if (plot && plot.layout && plot.layout.xaxis) {
      let { range } = plot.layout.xaxis;
      if (
        rangeInit &&
        rangeInit != null &&
        rangeInit.length > 1 &&
        range.length > 1
      ) {
        let plotlyDTick = dtickFormat(range[0], range[1]);
        let pTick2 = dtickFormat(rangeInit[0], rangeInit[1]);
        if (pTick2 != plotlyDTick) {
          this.setState({ rangeInit: range, plotlyDTick });
        }
      } else {
        this.setState({ rangeInit: range });
      }
    }
  };

  renderPlot = (chart) => {
    let { profile } = this.props.user,
      { staticHierarchy } = profile.organizationId;
    let {
      name,
      yAxisFormat,
      dtickFormat,
      benchmarkArray,
      kpiForPlotly,
      yRange,
    } = chart;
    let yTickFormat,
      plotlyData = [];
    let selectorOptions;
    if (!chart.layout) {
      if (yAxisFormat === "Absolute") {
        yTickFormat = ".3%";
      } else {
        yTickFormat = "";
      }

      plotlyData.concat(benchmarkArray);
      if (kpiForPlotly) {
        plotlyData = plotlyData.concat(kpiForPlotly);
      }

      let plotlyKpiData = plotlyData.filter(
        (data) =>
          data.name !== "Benchmark for KPI" &&
          data.x.length > 0 &&
          data.y.length > 0
      );
      let plotlyBenchMarkData = plotlyData.filter(
        (data) => data.name === "Benchmark for KPI"
      );
      let combinedPlotlyData = [...plotlyKpiData, ...plotlyBenchMarkData];

      let tickvalsString = null;
      if (combinedPlotlyData.length === 1) {
        if (combinedPlotlyData[0].x.length === 1) {
          tickvalsString = [combinedPlotlyData[0].x[0]];
        }
      }

      if (combinedPlotlyData.length > 1) {
        let tickvalsList = combinedPlotlyData.map((data) => {
          let xvalues = data.x;
          return xvalues;
        });
        let filteredTickvalsList = tickvalsList.filter(
          (tickValue) => tickValue.length === 1
        );
        if (
          tickvalsString == null &&
          tickvalsList.length > 0 &&
          tickvalsList.length === filteredTickvalsList.length
        ) {
          let firstTickVal = filteredTickvalsList[0][0];
          let filterTickVal = filteredTickvalsList.filter((tickVal) =>
            moment(tickVal[0]).isSame(firstTickVal, "month")
          );
          if (filterTickVal.length === filteredTickvalsList.length) {
            tickvalsString = [firstTickVal];
          }
        }
      }

      selectorOptions = {
        buttons: [
          {
            step: "month",
            stepmode: "backward",
            count: 4,
            label: "last 3m",
          },
          {
            step: "month",
            stepmode: "backward",
            count: 7,
            label: "6m",
          },
          {
            step: "year",
            stepmode: "backward",
            count: 1,
            label: "1y",
          },
          {
            step: "all",
          },
        ],
        // activecolor
      };
    }
    // if(chart && !chart.hasPlotlyData){
    //   this.setState({chart:{...chart, hasPlotlyData:true}})
    // }
    let officeNodeCheck = selectOfficeCheck(chart);
    let officeNode = findNodeinHierarchy(
      staticHierarchy,
      officeNodeCheck ? chart.selectedOffice.value : false,
      officeNodeCheck === false ? chart.officeId : false
    );

    let officeName = officeNode.title;

    let yLegend;
    let length = plotlyData.length;
    // -0.7
    if (length < 3) {
      yLegend = -0.5;
    } else if (length > 2 && length < 6) {
      yLegend = -0.5;
    } else if (length > 5 && length < 9) {
      yLegend = -0.7;
    } else if (length > 8 && length < 11) {
      yLegend = -0.9;
    } else if (length > 10) {
      yLegend = -1.2;
    }

    let margin;

    if (isMobile) {
      margin = {
        l: 0,
        r: 0,
        b: 20,
        t: 40,
        pad: 10,
      };
    } else {
      margin = {
        l: 90,
        r: 60,
        b: 20,
        t: 40,
        pad: 10,
      };
    }

    let u_chart = {
      ...chart,
      kpiData: plotlyData,
      plotlyDTick: chart.dtickFormat,
    };

    return (
      <div
        className=""
        // onMouseOver={this.handlePlotContainerClick}
        ref={(input) => {
          this.plotRef = input;
        }}
      >
        {console.log("plotlyDataplotlyData",u_chart)}
        {chart && chart.layout ? (
          <ChartEmptyState />
        ) : (
        <Plot
          data={plotlyData}
          layout={
            chart.layout
              ? {...chart.layout,   annotations: mergeLayoutAnnotations(chart.layout, this.state.annotations),}
              : {
                  showlegend: true,
                  autosize: true,
                  uirevision: true,
                  legend: chartParams(u_chart, "legend"),
                  paper_bgcolor: "white",
                  plot_bgcolor: "#e5ecf694",
                  margin: chartParams(u_chart, "margin"),
                  xaxis: chartParams(u_chart, "xaxis"),
                  yaxis: chartParams(u_chart, "yaxis"),
                  annotations: this.state.annotations,
                  // legend: {
                  //   bgcolor: "white",
                  //   // xanchor: "left",
                  //   orientation: "h",
                  //   y: legendPosition(plotlyData.length),
                  //   x: -0.05,
                  // },

                  // paper_bgcolor: "white",
                  // plot_bgcolor: "#e5ecf694",
                  // margin,
                  // xaxis: {
                  //   showgrid: true,
                  //   type: "date",
                  //   automargin: true,
                  //   title: {
                  //     text:
                  //       moment(chart.xMinDate).format("YYYY") ===
                  //       moment(chart.xMaxDate).format("YYYY")
                  //         ? `Date (${moment(chart.xMinDate).format("YYYY")})`
                  //         : "Date",
                  //     standoff: isMobile ? 10 : 20,
                  //   },
                  //   dtick: chart.dtickFormat,
                  //   tickformat:
                  //     typeof chart.dtickFormat != "number"
                  //       ? "%b<br>%Y"
                  //       : "%b %e",
                  //   tick0: chart.xMinDate,

                  //   ticks:'outside',
                  //   rangeselector: !isMobile ? selectorOptions : [],
                  //   // range: [
                  //   //   new Date(chart.xMinDate).getTime(),
                  //   //   new Date(chart.xMaxDate).getTime()
                  //   // ] ,
                  //   tickfont: { color: "#313236" },
                  // },
                  // yaxis: {
                  //   showgrid: true,
                  //   zerolinecolor: "#ffffff",
                  //   zerolinewidth: 1,
                  //   gridcolor: '#ffffff',
                  //   gridwidth: 1.2,
                  //   tickformat:
                  //     chart.yAxisFormat && chart.yAxisFormat == "Absolute"
                  //       ? undefined
                  //       : "%",
                  //   tickfont: { color: "#313236" },
                  //   range: chart.yRange,
                  //   automargin: true,
                  //   ticklabelposition:'outside left',
                  // },
                  // hovermode:'x',
                  hovermode: "closest",
                }
          }
          // useResizeHandler={true}
          scrollZoom={true}
          // config={{displayModeBar:false}}
          config={
            !chart.layout
              ? {
                  // displayModeBar:true,
                  scrollZoom: true,
                  // editable:isSafari?false:true,
                  modeBarButtonsToAdd: [
                    "drawline",
                    "drawopenpath",
                    "drawclosedpath",
                    "drawcircle",
                    "drawrect",
                    "eraseshape",
                  ],
                  displaylogo: false,
                  // staticPlot:(plotlyData && plotlyData.length>0)?false:true,
                  responsive: true,
                  toImageButtonOptions: {
                    format: "png", // one of png, svg, jpeg, webp
                    // moment(d.createdDate).format('MM/DD/YYYY')
                    filename: `${name} in office ${officeName} - ${moment(
                      new Date()
                    ).format("MM-D-YYYY")}`,
                    height: 600,
                    width: null,
                    scale: 1, // Multiply title/legend/axis/canvas sizes by this factor
                  },
                }
              : { displaylogo: false, responsive: true, scrollZoom: true }
          }
          className="singleChartViewContainer"
          style={{ width: "90%" }}
          // onUpdate={(figure) => this.onPlotlyUpdate(figure)}
          onClick={this.handleChartPointClick}
          onDoubleClick={this.handleChartPointDoubleClick}
        />
        )}

        <div>
          <div className="ml-5 mr-4 pb-4">
            <ChartAverageTable
              chartSelector={"_uuid" + chart._id}
              kpiForPlotly={chart.kpiForPlotly}
              yAxisFormat={chart.yAxisFormat}
              chart={chart}
            />
          </div>
        </div>
      </div>
    );
  };

  removeChart = (item) => {
    this.props.removeChart(item);
  };

  toggleTaskView = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  };

  renderPlotSize = (chart) => {
    if (chart) {
      let { col_size } = chart;
      let chart_size =
        col_size == 3
          ? "Small"
          : col_size == 4
          ? "Medium"
          : col_size == 6
          ? "Large"
          : col_size == 12
          ? "Full"
          : col_size;
      return (
        <Dropdown
          isOpen={this.state.dropdownOpen}
          toggle={this.toggleTaskView}
          className="dbPlotSizeDropdown"
        >
          <DropdownToggle caret className="dashboardChartSizeBtn">
            {chart_size}
          </DropdownToggle>
          <DropdownMenu className="singleTaskViewMenu">
            <DropdownItem header>Change chart size</DropdownItem>
            <DropdownItem
              className="chartBtnView"
              onClick={() => this.changeChartSize(3)}
            >
              Small
            </DropdownItem>
            <DropdownItem
              className="chartBtnView"
              onClick={() => this.changeChartSize(4)}
            >
              Medium
            </DropdownItem>
            <DropdownItem
              className="toolkitBtnView"
              onClick={() => this.changeChartSize(6)}
            >
              Large
            </DropdownItem>
            <DropdownItem
              className="toolkitBtnView"
              onClick={() => this.changeChartSize(12)}
            >
              Full
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      );
    }
  };

  changeChartSize = (size) => {
    let { chart } = this.state;
    chart.col_size = size;
    this.props.changeSize(chart);
  };

  closeViewChartModal = () => {
    this.setState({ filteredChart: {} });
    this.props.closeViewChartModal(this.state.chart);
  };

  navigateToChart = (chart) => {
    this.setState({ showViewChart: true });
  };

  toggleChartView = (value) => {
    this.setState((prevState) => ({
      isChartNotesDisplay: !prevState.isChartNotesDisplay,
    }));
  };

  toggleChartViewDd = () => {
    // dropdownChartViews
    this.setState((prevState) => ({
      dropdownSingleChartViewChange: !prevState.dropdownSingleChartViewChange,
    }));
  };

  openCreateChartReport = () => {
    this.setState((prevState) => ({
      openCreateChartReport: !prevState.openCreateChartReport,
    }));
  };

  applyDateFilter = (type) => {
    if (type == "clear") {
      this.setState({
        filteredChart: {},
        startDate: null,
        endDate: moment(new Date()),
      });
    } else {
      this.refreshChart();
    }
  };

  handleEndDateChange = (date) => {
    // date = date.format('YYYY-MM-DD') + 'T23:59:59.000Z';
    if (!date) {
      return;
    }
    if (this.state.startDate != null && date < this.state.startDate) {
      this.setState({
        endDate: this.state.endDate,
        error: false,
        // dateSelected
      });
    } else {
      this.setState({
        endDate: date,
        error: false,
        dateSelected: date,
      });
    }
  };

  handleStartDateChange = (date) => {
    // console.log("date:  ", date);
    // date = date.format('YYYY-MM-DD') + 'T00:00:00.000Z';
    if (!date) {
      return;
    }

    if (this.state.endDate !== null && date > this.state.endDate) {
      this.setState({
        startDate: this.state.startDate,
        error: false,
      });
    } else {
      this.setState({
        startDate: date,
        error: false,
        dateSelected: date,
      });
    }
  };

  openDatePicker = (id) => {
    document.getElementById(id).click();
  };

  renderDatePicker = () => {
    let { endDate, startDate, chart } = this.state;
    const chartIsLocked = chart && chart.lockedDate ? true : false;
    return (
      <span className="viewChartDateFilterContainer">
        <div className="inner-addon right-addon dateFilterPicker insightsDateFilterPicker">
          <span
            className="chart-reports-datepicker flaticon-calendar"
            onClick={() => this.openDatePicker("startDatePicker")}
          />
          <DatePicker
                     id="startDatePicker"
            className="chartViewReportsDatePicker"
            placeholderText="Select a start date"
            selected={startDate}
            onChange={(date) => this.handleStartDateChange(date)}
            selectsStart
            showYearDropdown
            startDate={startDate}
            endDate={endDate}
            maxDate={
              this.state.endDate
                ? moment(this.state.endDate)
                : moment(new Date())
            }
            disabled={chartIsLocked}
            // dateFormat="MM/DD/YYYY"
          />
        </div>

        <span className="mg10">to</span>

        <div className="inner-addon right-addon dateFilterPicker">
          <span className="chart-reports-datepicker">
            <span
              className="flaticon-calendar"
              onClick={() => this.openDatePicker("endDatePicker")}
            />
          </span>
          <DatePicker
                     id="endDatePicker"
            className="chartViewReportsDatePicker"
            selected={endDate}
            onChange={(date) => this.handleEndDateChange(date)}
            selectsEnd
            showYearDropdown
            startDate={startDate}
            endDate={endDate}
            maxDate={moment(new Date())}
            disabled={chartIsLocked}
            // disabled={!this.state.startDate}
            // dateFormat="MM/DD/YYYY"
          />
        </div>

        {startDate ? (
          <Button
            outline
            color="info"
            className="chartViewReportsDatePickerBtn"
            onClick={() => this.applyDateFilter()}
            disabled={chartIsLocked}
          >
            {" "}
            Apply{" "}
          </Button>
        ) : null}
        {startDate ? (
          <Button
            outline
            color="secondary"
            className="chartViewReportsDatePickerBtn"
            onClick={() => this.applyDateFilter("clear")}
          >
            {" "}
            Clear{" "}
          </Button>
        ) : null}
      </span>
    );
  };

  renderChartContainer = (chart) => {
    let {
      showManualEntryAnswersModal,
      clickedPoint,
      openCreateChartReport,
      showLinkedDashboards,
      dropdownSingleChartViewChange,
      dropdownFilter,
      isChartNotesDisplay,
    } = this.state;

    if (chart && chart._id) {
      let chart_owner =
        chart.createdBy.lastName && chart.createdBy.lastName != ""
          ? `${chart.createdBy.firstName} ${chart.createdBy.lastName}`
          : chart.createdBy.firstName;

      return (
        <div className={`viewChartContainer`}>
          <div className="viewChartHeadingContainer">
            <span className="linkedChartsTitle">
              {chart.name}
              <span className="dashboardChartItemMenu">
                <i
                  className="flaticon-close"
                  onClick={() => this.closeViewChartModal()}
                />
              </span>
            </span>
            <span className="dashboardPreviewCat">
              {" "}
              from {chart.category} added by {chart_owner}{" "}
              {chart.createdBy ? (
                <span style={{ fontSize: "0.6rem" }}>
                  {renderGenderPronoun(chart.createdBy)}
                </span>
              ) : (
                ""
              )}{" "}
              on {moment(this.props.chart.dashboardDate).format("MMMM D, YYYY")}{" "}
            </span>
          </div>

          <div className="col-md-12 col-lg-12 col-xs-12 viewChartModalBodyContainer">
            <div className="col-md-12 col-lg-12 col-xs-12 viewChartBoxStyle">
              <div className="viewChartHeadingsContainerTxt">Filters</div>
              <div className="info-msg-bg">
                Dashboard filters are overriding this chart's date filters. Any
                changes you make to the filters here won't show on the
                dashboard. <strong>**Note</strong> you can download the filtered
                chart by hovering over it and clicking on the camera icon
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path d="M10.5 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                  <path d="M2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2zm.5 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm9 2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z" />
                </svg>
                .
              </div>

              {this.renderDatePicker()}
            </div>
            {/* <div className="viewChartModalNote">**Note - all date changes made here are only previews, and will not be saved.</div> */}

            <div className="col-md-12 col-lg-12 col-xs-12 p-0 individualChartViewOptionsContainer">
              {/* <div className="vcfc_style_01"><span className="viewChartBoxStyle"><strong> {chart.category} </strong> category</span></div>
              <div className="vcfc_style_01"><span className="viewChartBoxStyle">added by <strong> {chart_owner} </strong> </span></div>
              <div className="vcfc_style_01"><span className="viewChartBoxStyle">on <strong> {moment(this.props.chart.dashboardDate).format('MMMM D, YYYY')} </strong> </span></div> */}
              {/* <div className="col-md-1 col-lg-1 col-xs-1 viewChartFilterContainer individualChartViewDropdownContainer p-0">
      <Dropdown isOpen={dropdownSingleChartViewChange} toggle={this.toggleChartViewDd} className="individualChartViewDropdown">
        <DropdownToggle caret className="individualChartViewBtnTxt">
        {!isChartNotesDisplay?chart_views[0]:chart_views[1]}
        </DropdownToggle>
        <DropdownMenu className="singleTaskViewMenu">
          <DropdownItem className="chartBtnView" onClick={()=>this.toggleChartView()}> 
            {!isChartNotesDisplay?chart_views[1]:chart_views[0]}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      </div> */}

              {/* <div 
      className={!openCreateChartReport?"addIndividualChartNotesBtnContainer btn btn-primary"
                    :"addIndividualChartNotesBtnContainer btn btn-outline-secondary"}
      onClick={()=>this.openCreateChartReport()}>
          {!openCreateChartReport?
          <span>Add Insight/Report</span>
          :<span>Cancel</span>
          }  
      </div> */}

              {/* {!isChartNotesDisplay?
          <div className="col-md-12 col-lg-12 col-xs-12 viewChartFilterContainer p-0">
              <div className="col-md-4 col-lg-4 col-xs-4 vcfc_style_01"><span className="viewChartBoxStyle"><strong> {chart.category} </strong> category</span></div>
              <div className="col-md-4 col-lg-4 col-xs-4 vcfc_style_01"><span className="viewChartBoxStyle">added by <strong> {chart_owner} </strong> </span></div>
              <div className="col-md-4 col-lg-4 col-xs-4 vcfc_style_01"><span className="viewChartBoxStyle">on <strong> {moment(this.props.chart.dashboardDate).format('MMMM D, YYYY')} </strong> </span></div>
          </div> : null 
      } */}
            </div>

            {/* {!isChartNotesDisplay? viewChartAnalyticsContainer */}
            <div
              className={`col-md-12 col-lg-12 col-xs-12 viewChartBoxStyle viewChartPlotContainer`}
            >
              <div className="viewChartHeadingsContainerTxt">Chart </div>

              {showManualEntryAnswersModal ? (
                <ManualEntryModal
                  questionAnswer={chart.kpiData}
                  clickedPoint={clickedPoint}
                  toggle={() => {
                    this.setState((p) => ({
                      showManualEntryAnswersModal: !p.showManualEntryAnswersModal,
                    }));
                  }}
                />
              ) : null}

              {this.renderPlot(chart)}
            </div>

            {this.props.group == null || this.props.group == undefined ? (
              showLinkedDashboards != true ? (
                <ChartInsights insights={chart.insights} chart={chart} />
              ) : (
                <div className="col-md-12 col-lg-12 col-xs-12 viewChartBoxStyle cc_linked_dashboards_container">
                  <div className="viewChartHeadingsContainerTxt">
                    Linked Dashboards
                  </div>
                  <ChartDashboards
                    closeViewChartModal={this.closeViewChartModal}
                    chart={chart}
                  />
                </div>
              )
            ) : null}

            {/* //  :
    //  <ChartInsights notes={chart.notes} chart={chart}/>
    //  } */}
          </div>
        </div>
      );
    } else {
      return <div>Retrieving charts...</div>;
    }
  };

  renderView = () => {
    let {
      chart,
      filteredChart,
      startDate,
      showManualEntryAnswersModal,
      clickedPoint,
      openCreateChartReport,
      dropdownSingleChartViewChange,
      dropdownFilter,
      isChartNotesDisplay,
    } = this.state;
    // console.log("startDate - ", startDate);
    if (filteredChart && Object.keys(filteredChart).length > 0) {
      return this.renderChartContainer(filteredChart);
    } else {
      return this.renderChartContainer(chart);
    }
  };

  processKpiData = (chart, selectedDates) => {

    chart = chartKpiDataFieldRefTransformationSingleChart(chart)
    const { profile } = this.props.user;
    // console.log('selectedDAtes')
    let max = 1,
      yRange,
      min = 0,
      y,
      layout,
      yPercent,
      xMaxDate,
      xMinDate,
      dtickFormatVal,
      yAxisFormat = chart.yAxisFormat,
      templateType;

    const kpi = chart.kpiData.map((kpi, index) => {
      // console.log("kpi processKpiData ---", kpi);
      let goalValue = this.kpiGoalValue(chart, kpi, index);
      let sortedKpiAggregate =
        kpi.score && kpi.score.length > 0
          ? sortBy(kpi.score, (kpi, i) => kpi.date)
          : [];
      let text,
        description,
        chartColor,
        x,
        y,
        yAlt,
        length,
        annotations,
        xaxis,
        yaxis;
      let kpiCount = index + 1;
      // console.log("sortedKpiAggregate", sortedKpiAggregate);
      //if (sortedKpiAggregate.length != 0) {

        let avgTenure = false
      text = sortedKpiAggregate.map((val) => {
        let value_floor = Math.round(val.value);

        if(val && val.avgTenure){
          avgTenure = true;
        }

        let textString = [];
        let ts;
        let ethnicity = val.numeratorEthnicity ? val.numeratorEthnicity : "";
        let kpiCode = kpi.kpiId.code;

        if (KPISbyMonth.indexOf(kpiCode) > -1) {
          let t = moment.utc(val.date).format("MMMM YYYY");
          textString.push(t);
        } else {
          let t = moment.utc(val.date).format("MMMM D, YYYY");
          textString.push(t);
        }

        if (
          !val.numeratorCount ||
          val.numeratorCount === undefined ||
          typeof val.numeratorCount == "undefined"
        ) {
          val.numeratorCount = 0;
        }
        if (val && val.numeratorType && val.totalEmployees) {
          if (kpi.kpiId.code === "COMP-1" || kpi.kpiId.code === "COMP-2") {
            ts = ethnicity
              ? `${ethnicity} ${val.numeratorType
                  .substring(1)
                  .replace(/-/g, ", ")
                  .toLowerCase()} count: ${val.numeratorCount}${
                  yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
                }, male count: ${
                  val.totalEmployees
                    ? val.totalEmployees - val.numeratorCount
                    : null
                }`
              : `${val.numeratorType
                  .substring(1)
                  .replace(/-/g, ", ")
                  .toLowerCase()} count: ${val.numeratorCount}${
                  yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
                }, male count: ${
                  val.totalEmployees
                    ? val.totalEmployees - val.numeratorCount
                    : null
                }`;
            textString.push(ts);
          } else {
            ts = ethnicity
              ? `${ethnicity} ${val.numeratorType
                  .substring(1)
                  .replace(/-/g, ", ")
                  .toLowerCase()} count: ${val.numeratorCount}${
                  yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
                }, total: ${val.totalEmployees ? val.totalEmployees : null}`
              : `${val.numeratorType
                  .substring(1)
                  .replace(/-/g, ", ")
                  .toLowerCase()} count: ${val.numeratorCount}${
                  yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
                }, total: ${val.totalEmployees ? val.totalEmployees : null}`;
            textString.push(ts);
          }
        } else if (val && val.numeratorType && !val.totalEmployees) {
          ts = ethnicity
            ? `${ethnicity} ${val.numeratorType
                .substring(1)
                .replace(/-/g, ", ")
                .toLowerCase()} count: ${val.numeratorCount}${
                yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
              }`
            : `${val.numeratorType
                .substring(1)
                .replace(/-/g, ", ")
                .toLowerCase()} count: ${val.numeratorCount}${
                yAxisFormat === "Absolute" ? ` (${value_floor}%)` : ""
              }`;
          textString.push(ts);
        } else if (val.totalEmployees && !val.numeratorType) {
          ts = `of total: ${val.totalEmployees ? val.totalEmployees : null}`;
          textString.push(ts);
        } else {
          textString.push("");
        }

        let goalText = "";
        if (goalValue && goalValue.number) {
          let diff = parseInt(goalValue.number) - Math.round(val.value);
          let res = Math.round(diff);
          if (res > 0) {
            goalText = `Until Goal met: ${res}%`;
            textString.push(goalText);
          } else {
            goalText = `Goal reached 😀👍!`;
            textString.push(goalText);
          }
        } else {
          goalText = "";
          textString.push(goalText);
        }

        if(val.avgTenure >=0 && val.avgTenure != null){
          const tenureString = `Avg Tenure: ${getAvgTenureFormatted(val.avgTenure)}`
          console.log({textString})
          if(textString[2]==""){
            textString[2] = tenureString
            textString[3] = ""
          }
          else{
            textString.push(tenureString)
          }
          
        }else{
          textString.push("")
        }

        console.log({textString})
        return textString;
      });

      if (yAxisFormat === "Absolute") {
        y = sortedKpiAggregate.map((kpi) => kpi.numeratorCount);
        yAlt = sortedKpiAggregate.map((kpi) => Math.round(kpi.value) / 100);
      } else {
        y = sortedKpiAggregate.map((kpi) => Math.round(kpi.value) / 100);
        yAlt = sortedKpiAggregate.map((kpi) => kpi.numeratorCount);
      }

      description = generateLegendTitle(
        kpi,
        kpi.kpiId.description,
        index,
        false,
        "",
        ""
      );

      sortedKpiAggregate.map((kpi) => {
        let yVal;
        if (yAxisFormat === "Absolute") {
          yVal =
            kpi.data.totalEmployees !== undefined
              ? kpi.data.totalEmployees
              : kpi.totalEmployees;
        } else {
          yVal = kpi.value / 100;
        }
        if (yVal > max) {
          max = yVal;
        }
      });

      if (yAxisFormat == "Absolute") {
        yRange = [-0.05, max + 100];
        yAxisFormat = "Absolute";
        templateType =
          "<b>%{text[0]}</b>, " +
          `<b>%{y:.0}</b> (KPI ${kpiCount}) <br>` +
          "%{text[1]}<br>" +
          "%{text[2]}<br>" +
          "%{text[3]}<br>"+
           +
          "<extra></extra>";
      } else {
        yRange = [-0.05, max + 0.1];
        yAxisFormat = "";
        templateType =
          "<b>%{text[0]}</b>, " +
          `<b>%{y:.0%}</b> (KPI ${kpiCount}) <br>` +
          "%{text[1]}<br>" +
          "%{text[2]}<br>" +
          "%{text[3]}<br>" +
          "<extra></extra>";
      }
      chartColor = chartLineColor(index);

      x = sortedKpiAggregate.map((kpi) => {
        let date1 = moment.utc(kpi.date).format("YYYY-MM-DD");
        if (xMinDate == undefined || xMinDate > date1) {
          xMinDate = date1;
        }

        if (xMaxDate == undefined || date1 > xMaxDate) {
          xMaxDate = date1;
        }
        return kpi.date;
      });
      length = x.length;
      dtickFormatVal = dtickFormat(xMinDate, xMaxDate, length);
      annotations = [];
      xaxis = "y";
      yaxis = "x";

      //} else {
      //  let endPlotlyDate = chart.endDate
      //    ? moment(chart.endDate).format("YYYY-MM-DD")
      //    : selectedDates.endDate
      //    ? moment(selectedDates.endDate).format("YYYY-MM-DD")
      //    : moment().format("YYYY-MM-DD");
      //  let startPlotlyDate = chart.startDate
      //    ? moment(chart.startDate).format("YYYY-MM-DD")
      //    : moment(selectedDates.startDate).format("YYYY-MM-DD");
      //  layout = {
      //    yaxis: {
      //      visible: false,
      //    },
      //    autosize: true,
      //    paper_bgcolor: "#F3F3F4",
      //    plot_bgcolor: "#F3F3F4",
      //    annotations: [
      //      {
      //        text: "No matching data found",
      //        xref: "paper",
      //        yref: "paper",
      //        showarrow: false,
      //        font: {
      //          size: 20,
      //          //  "color": "red"
      //        },
      //      },
      //    ],
      //    margin: {
      //      //  t: 10,
      //      //  l: 30,
      //      //  r: 30,
      //      t: 0,
      //      b: 30,
      //    },

      //    xaxis: {
      //      type: "date",
      //      autorange: false,
      //      fixedrange: true,
      //      range: [startPlotlyDate, endPlotlyDate],
      //      showgrid: false,
      //    },

      //    hovermode: "closest",
      //    showlegend: false,
      //  };
      //}

      return {
        name: `${description}`,
        description,
        y,
        yAlt,
        x,
        text,
        hovertemplate: templateType,
        type: "scatter",
        line: this.chartLineMarkerGenerator(chartColor, "line"),
        marker: this.chartLineMarkerGenerator(chartColor, "marker", x.length),
        xaxis,
        yaxis,
        id: kpi.kpiId._id,
        lines: "scatter",
        mode: length > 12 ? "lines" : "lines+markers",
        annotations,
        // ...result
      };
    });

    let benchmark = {};
    if (chart.benchmarkData) {
      let { industriesList } = this.state;
      let industry = find(industriesList, {
        _id: profile.organizationId.industry,
      });
      let { score } = chart.benchmarkData;
      let sortedDataArray = sortBy(score, (data) => data.date);
      const singleBenchmark = sortedDataArray.length === 1;
      benchmark.name = `Benchmark`;

      if (chart.kpiData.length === 0) {
        benchmark.description = generateLegendTitle(
          null,
          chart.category,
          0,
          true,
          industry ? industry.name : "",
          chart.benchmarkData.location
        );
      } else {
        benchmark.description = generateLegendTitle(
          chart.kpiData[0],
          chart.kpiData[0].kpiId.description,
          0,
          true,
          industry ? industry.name : ""
        );
      }

      benchmark.x = sortedDataArray.map((benchmark) => benchmark.date);
      benchmark.y = sortedDataArray.map((benchmark) => benchmark.value / 100);
      benchmark.type = "scatter";
      benchmark.line = benchmarkLineTypes[0];
      benchmark.marker = singleBenchmark
        ? plotlyMarkerTypes[3]
        : plotlyMarkerTypes[0];
      benchmark.xaxis = "x";
      benchmark.yaxis = "y";
    }

    const showEmptyLayout = checkNoDataLayoutValidity(kpi);
    if (showEmptyLayout) {
      layout = getEmptyGraphLayoutObject({
        l: 50,
        r: 30,
        t: 30,
        b: 40,
      });
    }
    chart.layout = layout;
    chart.benchmark = benchmark;
    chart.kpiForPlotly = kpi;
    chart.yAxisFormat = yAxisFormat;
    chart.yRange = yRange;
    chart.xMinDate = xMinDate;
    chart.xMaxDate = xMaxDate;
    chart.dtickFormat = dtickFormatVal;
    // console.log('process ch: ', chart)
    return chart;
    // chart.kpiDescription = description
  };

  render() {
    return this.renderView();
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onKpiMasterListFetched: (data) =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    onChartSelected: (chart) => dispatch(actionCreators.onChartSelected(chart)),
    updateReport: (dashboard) =>
      dispatch(actionCreators.updateReport(dashboard)),
  };
};

// export default LinkedCharts;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(ViewSingleChart, axios)));
